var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.925 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mastercard_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h25.925v16H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mastercard_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d90010",
    d: "M9.925 8a7.984 7.984 0 013.038-6.273 8 8 0 100 12.545A7.984 7.984 0 019.925 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e54800",
    d: "M9.925 8a7.984 7.984 0 003.038 6.273 7.995 7.995 0 000-12.545 7.984 7.984 0 00-3.038 6.273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f78b00",
    d: "M17.924 0a7.962 7.962 0 00-4.962 1.727 8 8 0 010 12.545A8 8 0 1017.924 0"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNS45MjUgMTYiPjxkZWZzPjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGgyNS45MjV2MTZIMHoiLz48L2NsaXBQYXRoPjwvZGVmcz48ZyBjbGlwLXBhdGg9InVybCgjYSkiPjxwYXRoIGZpbGw9IiNkOTAwMTAiIGQ9Ik05LjkyNSA4YTcuOTg0IDcuOTg0IDAgMCAxIDMuMDM4LTYuMjczIDggOCAwIDEgMCAwIDEyLjU0NUE3Ljk4NCA3Ljk4NCAwIDAgMSA5LjkyNSA4Ii8+PHBhdGggZmlsbD0iI2U1NDgwMCIgZD0iTTkuOTI1IDhhNy45ODQgNy45ODQgMCAwIDAgMy4wMzggNi4yNzMgNy45OTUgNy45OTUgMCAwIDAgMC0xMi41NDUgNy45ODQgNy45ODQgMCAwIDAtMy4wMzggNi4yNzMiLz48cGF0aCBmaWxsPSIjZjc4YjAwIiBkPSJNMTcuOTI0IDBhNy45NjIgNy45NjIgMCAwIDAtNC45NjIgMS43MjcgOCA4IDAgMCAxIDAgMTIuNTQ1QTggOCAwIDEgMCAxNy45MjQgMCIvPjwvZz48L3N2Zz4=";
export { SvgMastercard as ReactComponent };